const DEFAULT_FEATURE_FLAGS = {
  gallery: false,
  goalseek: false,
  tour: true,
  privateShareLink: false,
  presentModeBeta: true,
  showPlaceholder: false,
  morphingShareBar: false,
  community: false,
};

export function getFeatureFlags() {
  const configFlags = typeof window !== 'undefined' ? (window.IC_CONFIG?.features || {}) : {};
  return { ...DEFAULT_FEATURE_FLAGS, ...configFlags };
}

export function isFeatureEnabled(flagName, fallbackValue = false) {
  const flags = getFeatureFlags();
  if (Object.hasOwn(flags, flagName)) {
    return Boolean(flags[flagName]);
  }
  return Boolean(fallbackValue);
}
